import { KNOWLEDGE_SCOPE_META, type KnowledgeScope } from '../constants/knowledgeScope'
import { formatDate } from './ui'
import { tagsToArray } from './knowledgeTags'
import '../pages/KnowledgeCreateDoc.css'

export type KnowledgeItemMeta = {
  title?: string
  folder_id?: number | null
  category?: string
  tags?: string
  summary?: string
  doc_status?: string
  created_by_name?: string
  created_at?: string | null
}

type Props = {
  item: KnowledgeItemMeta
  scope: KnowledgeScope
  folderName?: string
}

export function KnowledgeItemMetaPanel({ item, scope, folderName }: Props) {
  const tagList = tagsToArray(item.tags)
  const isDraft = (item.doc_status || 'normal') === 'draft'

  return (
    <div className="kb-create-doc-attrs-pane">
      <div className="kb-attrs-sheet">
        <div className="kb-attrs-row kb-attrs-row--1">
          <div className="kb-attrs-cell">
            <div className="kb-attrs-label">创建人</div>
            <div className="kb-attrs-value kb-attrs-value--text">{item.created_by_name || '—'}</div>
          </div>
        </div>
        {item.created_at ? (
          <div className="kb-attrs-row kb-attrs-row--1">
            <div className="kb-attrs-cell">
              <div className="kb-attrs-label">创建时间</div>
              <div className="kb-attrs-value kb-attrs-value--text">{formatDate(item.created_at)}</div>
            </div>
          </div>
        ) : null}
        <div className="kb-attrs-row kb-attrs-row--1">
          <div className="kb-attrs-cell">
            <div className="kb-attrs-label">所属文件夹</div>
            <div className="kb-attrs-value kb-attrs-value--text">{folderName || '—'}</div>
          </div>
        </div>
        <div className="kb-attrs-row kb-attrs-row--2">
          <div className="kb-attrs-cell">
            <div className="kb-attrs-label">文档状态</div>
            <div className="kb-attrs-value kb-attrs-value--text">{isDraft ? '草稿' : '正常'}</div>
          </div>
          <div className="kb-attrs-cell">
            <div className="kb-attrs-label">知识库</div>
            <div className="kb-attrs-value kb-attrs-value--text">{KNOWLEDGE_SCOPE_META[scope].title}</div>
          </div>
        </div>
        <div className="kb-attrs-row kb-attrs-row--2 kb-attrs-row--tall">
          <div className="kb-attrs-cell kb-attrs-cell--top">
            <div className="kb-attrs-label">文档类型</div>
            <div className="kb-attrs-value kb-attrs-value--text">{item.category || '—'}</div>
          </div>
          <div className="kb-attrs-cell kb-attrs-cell--top">
            <div className="kb-attrs-label">摘要</div>
            <div className="kb-attrs-value kb-attrs-value--text kb-attrs-value--multiline">
              {item.summary || '—'}
            </div>
          </div>
        </div>
        <div className="kb-attrs-row kb-attrs-row--1">
          <div className="kb-attrs-cell">
            <div className="kb-attrs-label">标签</div>
            <div className="kb-attrs-value kb-attrs-value--text">
              {tagList.length ? tagList.join('、') : '—'}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
